import { BackofficeProductsRequestInterface } from '../../../../interfaces/request/backoffice/backoffice-products/backoffice-products-request-interface';

export class BackofficeProductsRequestModel implements BackofficeProductsRequestInterface {
  creationDateStart?: string = '';
  creationDateEnd?: string = '';
  featureName?: string = '';
  pageSize?: number;
  page?: number;

  constructor(init?: Partial<BackofficeProductsRequestModel>) {
    Object.assign(this, init);
  }
}
